module.exports = __webpack_public_path__ + "img/West Virginia outline.96072f15.png";